// =======================
// Require
// =======================
var page = require('page');
var config = (function (props) {
                        var self = {};
                        var _getByPropPath = function (o, s) {
                            // http://stackoverflow.com/a/6491621
                            s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                            s = s.replace(/^\./, '');           // strip a leading dot
                            var a = s.split('.');
                            for (var i = 0, n = a.length; i < n; ++i) {
                                var k = a[i];
                                if (k in o) {
                                    o = o[k];
                                } else {
                                    return;
                                }
                            }
                            return o;
                        };

                        self.get = function (a) {
                            return _getByPropPath(props, a);
                        };

                        return self;
                    })({"Client":{"fadeInterval":500,"dataTables":{"fixedHeader":{"header":true,"footer":false},"ordering":true,"paging":true,"processing":true,"scrollX":true,"scrollY":true,"language":{"paginate":{"first":"先頭へ","previous":"前へ","next":"次へ","last":"最後へ"},"aria":{"paginate":{"first":"先頭へ","previous":"前へ","next":"次へ","last":"最後へ"}},"decimal":",","thousands":",","emptyTable":"対象データなし","lengthMenu":"<select><option value='10'>10件</option><option value='50'>50件</option><option value='100'>100件</option><option value='200'>200件</option><option value='-1'>全て</option></select>表示","loadingRecords":"Now Loading...","processing":"Now Processing...","search":"全文検索：","searchPlaceholder":"検索ワード","zeroRecords":"対象データなし","info":"_PAGE_ / _PAGES_ ページを表示中","infoEmpty":"対象データなし","infoFiltered":"(全_MAX_件からフィルタリング中)"}}}});;
var error = require('./error');
var i18n = require('./i18n');

// =======================
// Controllers
// =======================
var controller = {
  navbar: require('./lib/navbar'),
  menu: require('./lib/menu'),
  profile: require('./lib/profile'),
  user: require("./lib/user"),
  role: require("./lib/role"),
  client: require("./lib/client"),
  setting: require("./lib/setting"),
  changePassword: require('./lib/changePassword')
}

// =======================
// Main
// =======================
module.exports = {
  init: init
}

// Routing Setup
// NOTE: HTML Anchor tag click -> event bind
//             to exclude link from page.js -> add not empty target attfibute like target='_self'
function init() {
  return new Promise(function(resolve, reject) {
    page.base('/');

    page('/', function(ctx) {
      Promise.resolve()
        .then(controller.menu.show)
        .catch(error.show)
      ;
    });
    page.exit('/', function(ctx, next) {
      Promise.resolve()
        .then(controller.menu.hide)
        .then(next)
        .catch(error.show)
      ;
    });

    page('login', function(ctx) {
      Promise.resolve()
        .then(controller.changePassword.init)
        .catch(error.show)
    });
    page.exit('login', function(ctx, next) {
      Promise.resolve()
        .then(controller.changePassword.destroy)
        .then(next)
        .catch(error.show)
      ;
    });
    page('api/oauth2/authorize', function(ctx) {
      Promise.resolve()
        .then(controller.changePassword.init)
        .catch(error.show)
    });
    page.exit('api/oauth2/authorize', function(ctx, next) {
      Promise.resolve()
        .then(controller.changePassword.destroy)
        .then(next)
        .catch(error.show)
      ;
    });

    page('profile', function(ctx) {
      Promise.resolve()
        .then(controller.profile.show)
        .catch(error.show)
      ;
    });
    page.exit('profile', function(ctx, next) {
      Promise.resolve()
        .then(controller.profile.hide)
        .then(next)
        .catch(error.show)
      ;
    });

    page('user', function(ctx) {
      Promise.resolve()
        .then(controller.user.show)
        .catch(error.show)
      ;
    });
    page.exit('user', function(ctx, next) {
      Promise.resolve()
        .then(controller.user.hide)
        .then(next)
        .catch(error.show)
      ;
    });

    page('role', function(ctx) {
      Promise.resolve()
        .then(controller.role.show)
        .catch(error.show)
      ;
    });
    page.exit('role', function(ctx, next) {
      Promise.resolve()
        .then(controller.role.hide)
        .then(next)
        .catch(error.show)
      ;
    });

    page('client', function(ctx) {
      Promise.resolve()
        .then(controller.client.show)
        .catch(error.show)
      ;
    });
    page.exit('client', function(ctx, next) {
      Promise.resolve()
        .then(controller.client.hide)
        .then(next)
        .catch(error.show)
      ;
    });

    page('setting', function(ctx) {
      Promise.resolve()
        .then(controller.setting.show)
        .catch(error.show)
      ;
    });
    page.exit('setting', function(ctx, next) {
      Promise.resolve()
        .then(controller.setting.hide)
        .then(next)
        .catch(error.show)
      ;
    });

    page();
    resolve();
  });
}

